import * as status from '../scripts/ComplexityPasswordStatusCode'

export function validatePasswordComplexity(password) {
    return new Promise(resolve => {
        var numberLetters = GetNumberAlphaCharacters(password);
        var numberLowerCaseLetters = GetNumberLowerCaseCharacters(password);
        var numbers = GetNumbers(password);
        var numberSpecialCharacters = GetNumberSpecialCharacters(password);

        let statusComplexity = status.Success;

        if (numbers <= 0 && numberSpecialCharacters <= 0) {
            statusComplexity = status.Error_Number_SpecialCharacter;
        } else if (numberLetters < 2) {
            statusComplexity = status.Error_Two_Letters;
        } else if (numberLowerCaseLetters == 0 || (numberLetters - numberLowerCaseLetters) == 0) {
            statusComplexity = status.Error_Min_Maj_Letters;
        }

        return resolve(statusComplexity);
    });
}

export function validateRuntimePasswordComplexity(password) {
    return new Promise(resolve => {
        var numberLetters = GetNumberAlphaCharacters(password);
        var numberLowerCaseLetters = GetNumberLowerCaseCharacters(password);
        var numbers = GetNumbers(password);
        var numberSpecialCharacters = GetNumberSpecialCharacters(password);

        let statusSpecialChar = true;
        let statusTwoLetters = true;
        let statusMajLetters = true;

        if (numbers <= 0 && numberSpecialCharacters <= 0) {
            statusSpecialChar = false;
        }

        if (numberLetters < 2) {
            statusTwoLetters = false;
        }

        if (numberLowerCaseLetters == 0 || (numberLetters - numberLowerCaseLetters) == 0) {
            statusMajLetters = false;
        }

        return resolve({ statusSpecialChar, statusTwoLetters, statusMajLetters });
    });
}

// Return the number of letters
function GetNumberAlphaCharacters(pass) {
    var i;
    var count = 0;
    var alphaLetters = /^[a-zA-Z]+/;

    for (i = 0; i < pass.length; i++) {
        if ((pass.substr(i, 1)).match(alphaLetters)) {
            count++;
        }
    }

    return count;
}

// Return the number of lower case letters
function GetNumberLowerCaseCharacters(pass) {
    var i;
    var count = 0;
    var alphaLowerLetters = /^[a-z]+/;

    for (i = 0; i < pass.length; i++) {
        if ((pass.substr(i, 1)).match(alphaLowerLetters)) {
            count++;
        }
    }

    return count;
}

// Return the number of number [0-9]
function GetNumbers(pass) {
    var i;
    var count = 0;
    var numbers = /^[0-9]+/;

    for (i = 0; i < pass.length; i++) {
        if ((pass.substr(i, 1)).match(numbers)) {
            count++;
        }
    }

    return count;
}

// Return the number of special characters
function GetNumberSpecialCharacters(pass) {
    var i;
    var count = 0;
    var specialCharacters = /^[!@#$%^&*(),_.<>/;:{}'"[\]]+/;

    for (i = 0; i < pass.length; i++) {
        if ((pass.substr(i, 1)).match(specialCharacters)) {
            count++;
        }
    }

    return count;
}